import { JobSalaryType, JobStatus, JobType } from "@relode/core/domain";

import { Location } from ".";

export class CandidateJobDetails {
    jobId: number;
    jobName: string;
    teamName: string;
    teamBackground: string;
    // jobTypeName: string;
    // jobTypeId: number;
    jobType: JobType;
    location: Location;
    contractStartDate: Date;
    contractEndDate: Date;
    hoursPerWeek: number;
    billRateInUSDollars: number;
    jobSalaryType: JobSalaryType;
    jobSalary: number;
    status: JobStatus;
}
